// @ts-expect-error - TS2307 - Cannot find module 'src/types/thunk-decorators' or its corresponding type declarations.
import type {KeyedThunkAction} from 'src/types/thunk-decorators';
import type {ApiError} from 'src/utils/errors';
import {useSelector} from 'react-redux';
import {inflight, hasError} from 'src/utils/redux';

import {useRef} from 'react';
import usePrevious from 'src/hooks/usePrevious';


export function useInflight(func: KeyedThunkAction<unknown>): boolean {
  return useSelector((state) => inflight(state, func));
}

export function useHasError(func: KeyedThunkAction<unknown>): ApiError {
  return useSelector((state) => hasError(state, func));
}

export function useHasNetworkRequestCompleted(
  func: KeyedThunkAction<unknown>,
): boolean {
  const inflightValue = useInflight(func);
  const previousInflightValue = usePrevious(inflightValue);
  const hasCompleted = useRef(false);
  if (previousInflightValue === true && inflightValue === false) {
    hasCompleted.current = true;
  }
  return hasCompleted.current;
}
